import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_topics_are_included_win_the_facs_written_9'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_topics_are_included_win_the_facs_written_9',
  name: "Which of the following topics are included within the facility's written policies and procedures for grievance systems?",
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'GRIEVANCE_SYSTEM_AND_PROCESS',
      text: 'Grievance system and process',
      externalIds: [
        {
          id: 'ms-1--11-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_REPRISAL_FOR_WORKERS_FILING_A_GRIEVANCE_COMPLAINT',
      text: 'Non-reprisal for workers filing a grievance/complaint',
      externalIds: [
        {
          id: 'ms-1--11-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EQUAL_ACCESS_TO_GRIEVANCE_SYSTEMS_FOR_FEMALE_AND_MALE_WORKERS_A',
      text: 'Equal access to grievance systems for female and male workers and workers who neither identify as male or female',
      externalIds: [
        {
          id: 'ms-pla-25x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKER_FEEDBACK',
      text: 'Worker Feedback',
      externalIds: [
        {
          id: 'ms-1--11-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EQUAL_IMPORTANCE_GIVEN_TO_ALL_CONCERNS_AND_GRIEVANCES_',
      text: 'Equal importance given to all concerns and grievances ',
      externalIds: [
        {
          id: 'ms-pla-26x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'COMMITMENT_TO_CONFIDENTIALITY_THROUGHOUT_THE_ENTIRE_GRIEVANCE_P',
      text: 'Commitment to confidentiality throughout the entire grievance process',
      externalIds: [
        {
          id: 'ms-pla-27x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PROVIDING_TIME_OFF_INCLUDING_MONETARY_COMPENSATION_DURING_A_GRI',
      text: 'Providing time off (including monetary compensation) during a grievance process',
      externalIds: [
        {
          id: 'ms-pla-28x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-1--11-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-1--11-4f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'GRIEVANCE_SYSTEM_AND_PROCESS',
                'NON_REPRISAL_FOR_WORKERS_FILING_A_GRIEVANCE_COMPLAINT',
                'EQUAL_ACCESS_TO_GRIEVANCE_SYSTEMS_FOR_FEMALE_AND_MALE_WORKERS_A',
                'WORKER_FEEDBACK',
                'EQUAL_IMPORTANCE_GIVEN_TO_ALL_CONCERNS_AND_GRIEVANCES_',
                'COMMITMENT_TO_CONFIDENTIALITY_THROUGHOUT_THE_ENTIRE_GRIEVANCE_P',
                'PROVIDING_TIME_OFF_INCLUDING_MONETARY_COMPENSATION_DURING_A_GRI',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-24',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 19710,
  sectionId: '2.2.6.10',
  impactArea: 'Policies and Procedures',
  impactAreaId: 'POLICIES_AND_PROCEDURES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
